import { render, staticRenderFns } from "./svgEmail.vue?vue&type=template&id=2d39f932&scoped=true"
import script from "./svgEmail.vue?vue&type=script&lang=js"
export * from "./svgEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39f932",
  null
  
)

export default component.exports